"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "actionAsyncStorage", {
    enumerable: true,
    get: function() {
        return _actionasyncstorageinstance.actionAsyncStorage;
    }
});
const _actionasyncstorageinstance = require("./action-async-storage-instance");

//# sourceMappingURL=action-async-storage.external.js.map